import { ChevronLeft, ChevronRight } from '../../../../modules/design-system';

export interface TierSelectorArrowProps {
  direction: 'left' | 'right';
  onClick: () => void;
}

/**
 * Circular scroll-nav button shown at either edge of `TierSelector`
 * while that side still has tiers scrolled out of view. Colours are
 * Design Constructor knobs (`--co-TierSelector-arrow*`) so operators
 * can restyle it per theme; defaults are a translucent dark pill that
 * reads over the fade mask on both light and dark pack artwork.
 */
export function TierSelectorArrow({ direction, onClick }: TierSelectorArrowProps) {
  const Icon = direction === 'left' ? ChevronLeft : ChevronRight;
  const sideClass = direction === 'left' ? 'left-0' : 'right-0';

  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={direction === 'left' ? 'Scroll tiers left' : 'Scroll tiers right'}
      data-co-component="TierSelectorArrow"
      className={`
        absolute top-1/2 z-10 -translate-y-1/2 ${sideClass}
        flex items-center justify-center rounded-full border
        cursor-pointer transition-transform duration-150
        hover:scale-105 active:scale-95
        hover:[background:var(--co-TierSelector-arrowBgHover,rgba(20,20,20,0.75))]
      `}
      style={{
        width: 'var(--co-TierSelector-arrowSize, 28px)',
        height: 'var(--co-TierSelector-arrowSize, 28px)',
        color: 'var(--co-TierSelector-arrowColor, #ffffff)',
        background: 'var(--co-TierSelector-arrowBg, rgba(20,20,20,0.55))',
        borderColor: 'var(--co-TierSelector-arrowBorder, rgba(255,255,255,0.15))',
      }}
    >
      <Icon size={16} strokeWidth={2.5} />
    </button>
  );
}
